<template>
    <ul class="text-gray-900">
        <li
            v-for="(item, index) in items"
            :key="index">
            {{ item.name }}
        </li>
    </ul>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const items = computed(() => params?.value?.data.categoryVehicleDetail)
</script>
